import {
    registerBlockType,
} from "@wordpress/blocks";

import {
    Fragment,
    RawHTML
} from "@wordpress/element";

import {
    MediaUpload ,
    AlignmentToolbar,
    InspectorControls,
    InnerBlocks,
    PanelColorSettings,
    BlockAlignmentToolbar,
    RichText
} from "@wordpress/editor";

import {
    PanelBody ,
    TextControl,
    Button,
    SelectControl,
    RangeControl,
    ToggleControl,
    ServerSideRender
} from "@wordpress/components";

var withSelect = wp.data.withSelect;

var components_options = [];
for(var component_id in block_civicrm.components){
    components_options.push({
        label: block_civicrm.components[component_id].label,
        value: component_id
    });
}

var block_attributes = {
    component: {
        type: 'string',
    },
    id: {
        type: 'string',
    },
    gid: {
        type: 'string',
    },
    cid: {
        type: 'string',
    },
};
for(var co in block_civicrm.options){
    var default_value = null;
    for(var o in block_civicrm.options[co].options){
        if(default_value === null){
            default_value = o;
            break;
        }
    }
    block_attributes[block_civicrm.options[co].key] = {
        type: 'string',
        default: default_value,
    };
}


registerBlockType("blocks-for-civicrm/civicrm", {
    title: block_civicrm.i18n.title,
    description: block_civicrm.i18n.description,
    icon: "screenoptions",
    category: "widgets",
    attributes: block_attributes,

    edit({className, attributes, setAttributes, isSelected}){
        const{
            component,
            id,
            gid,
            cid,
        } = attributes;

        const setComponent = component => setAttributes({component});

        // Generate setters for ID fields
        const setId = {
            'id': id => setAttributes({id}),
            'gid': gid => setAttributes({gid}),
            'cid': cid => setAttributes({cid}),
        }
        var idControl = null;
        if(typeof(block_civicrm.id_options[component]) !== 'undefined'){
            var idSelect = block_civicrm.components[component].select;
            idControl = (
                <TextControl
                label={idSelect.key}
                name={idSelect.key}
                onChange={setId[idSelect.key]}
                value={attributes[idSelect.key]}
                />
            );
            if(block_civicrm.id_options[component].length){
                idControl = (
                    <SelectControl
                        label={block_civicrm['i18n']['options'][idSelect.key]}
                        name={idSelect.key}
                        onChange={setId[idSelect.key]}
                        value={attributes[idSelect.key]}
                        options={block_civicrm.id_options[component]}
                    />
                );
            }
        }

        function getControl(item, value){
            var control_options = [];
            for(var o in item.options){
                control_options.push({
                    label: item.options[o],
                    value: o,
                })
            }

            return (<SelectControl
                label={block_civicrm['i18n']['options'][item.key]}
                name={item.key}
                onChange={setOptions[item.key]}
                value={value}
                options={control_options}
                />);
        }

        // Generate setters from options
        var setOptions = [];
        var options = [];
        for(var co in block_civicrm.options){
            eval('setOptions["'+block_civicrm.options[co].key+'"] = '+block_civicrm.options[co].key+' => setAttributes({'+block_civicrm.options[co].key+'})');
            if(block_civicrm.options[co].components === true || block_civicrm.options[co].components.indexOf(component)>-1){
                options.push(getControl(block_civicrm.options[co], attributes[block_civicrm.options[co].key]));
            }
        }

        // Generate  shortcode preview
        var attrs = "";
        for(var attr in attributes){
            attrs+=' '+attr+'="'+attributes[attr]+'"';
        }

        return (
            <Fragment>
                <div class="blocks-for-civicrm-preview">
                    <SelectControl
                        label={block_civicrm.i18n.component}
                        name="component"
                        onChange={setComponent}
                        value={component}
                        options={components_options}
                    />

                    {idControl}
                    {options}

                </div>

                {isSelected && (

                    <InspectorControls>
                        <code>[civicrm {attrs}]</code>
                    </InspectorControls>

                )}
            </Fragment>
        )
    },

    save: function save(props) {
        const { attributes, innerBlocks } = props;
        var attrs = "";
        for(var attr in attributes){
            attrs+=' '+attr+'="'+attributes[attr]+'"';
        }
        return (
            <RawHTML>{'[civicrm'+attrs+']'}</RawHTML>
        );
    }
});
